export enum QuestionAnswer {
  yes = 'YES',
  no = 'NO',
  na = 'NA'
}
